/** Specific vocabulary to be used to give repeatable content a distinct brand voice
 * @example
 * import { ArgosVocab } from '@sainsburys-tech/vocab'
 *
 * return (
 *   <Button>{ ArgosVocab.ADD_TO_TROLLEY }</Button>
 * )
 * @example
 * const Button = () => {
 * const { ADD_TO_TROLLEY } = useVocab()
 * return (
 *   <Button>{ ADD_TO_TROLLEY }</Button>
 * )
 */
const ArgosVocab = {
  BRAND_NAME: 'Argos',
  ADD_TO_TROLLEY: 'Add to trolley',
  ITEM_CONTAINER: 'trolley'
}

export default ArgosVocab
